<template>
  <transition name="van-fade">
    <div v-if="visible" class="van-toast" :class="mode">
      <i v-if="mode === 'loading'" class="van-loading"></i>
      <span class="text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'text', // 'text' or 'loading'
    }
  },
  data() {
    return {
      visible: false,
      message: '',
      timer: null
    };
  },
  methods: {
    show(msg, duration = 2000) {
      this.message = msg;
      this.visible = true;
      clearTimeout(this.timer);
      if (this.mode !== 'loading') {
        this.timer = setTimeout(() => {
          this.visible = false;
        }, duration);
      }
    },
    hide() {
      this.visible = false;
      clearTimeout(this.timer);
    }
  }
};
</script>

<style scoped>
.van-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 160px;
  max-width: 70%;
  padding: 20px 28px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 28px;
  border-radius: 16px;
  text-align: center;
  box-sizing: border-box;
  z-index: 9999;
}

.van-toast.loading {
  padding: 28px;
}

.van-toast .van-loading {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.van-fade-enter-active,
.van-fade-leave-active {
  transition: opacity 0.3s ease;
}
.van-fade-enter,
.van-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/msgBox/toast.vue